import moment from 'moment'
import routes from '../Constants/routes'

const dateUtils = {
    getCurrentDate() {
        return this.formatDate(new Date())
    },

    formatDate(date) {
        date = new Date(date)
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        const yyyy = date.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        const formatted = yyyy + '-' + mm + '-' + dd;
        return formatted;
    },
    
    formatDateSpan(date1, date2) {
        return `${this.formatDate(date1)} - ${this.formatDate(date2)}`
    },

    formatDateAndTime(date) {
        date = new Date(date)

        if (date.getTime() <= new Date(0).getTime())
            return ""

        return date.toLocaleDateString("sv-SE") + " " + date.toLocaleTimeString("sv-SE", { hour: '2-digit', minute: '2-digit' });
    },

    formatArrayDates(array, property) {
        if (array && property) {
            return array.map(date => {
                return Object.assign({}, date, {
                    [property]: new Date(date[property])
                });
            });
        }
    },

    createBookingLink(appointment) {
        var date = moment(appointment.time).format().replace(/[^A-Z0-9]+/ig, "")
        var link = `https://www.google.com/calendar/render?action=TEMPLATE&text=Återkomst&details=${window.location.origin + routes.appointmentDetails(appointment.id)}&location=&dates=${date}Z/${date}`;

        return link
    },

    checkForInvalidDate(date) {
        if (date === '1900-01-01')
            return '';

        return date;
    }
};

export default dateUtils;
